import React from "react";
import classes from "../Navbar/Navbar.module.css";
import logo from "../utils/images/JA-logo.png";
import { Link, useLocation } from "react-router-dom";
import SettingsPhoneIcon from "@mui/icons-material/SettingsPhone";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";

// import ges from "../utils/images/greenestep.png"

const Navbar = () => {
  const navigate = useNavigate();

  const location = useLocation();
  console.log(location.pathname)
  const item = localStorage.getItem("origin");
  const handleGoPrevious=()=>{
    if (location.pathname !=="/user/findcontact")
    navigate(-1);
    
  }
  return (
    <>
      <div
        // hidden={item === "external" ? true : false}
        className={classes.navBar}
      >
        {item !== "external" ? (
          <div className={classes.logo}>
            <img src={logo} alt="logo" />
          </div>
        ) : (
          <div hidden={location.pathname===("/user/findcontact" || "/user/ja")?true:false} className={classes.logo}>

            <div  onClick={handleGoPrevious}  className={classes.NavTabName}>
            <button disabled={location.pathname===("/user/findcontact" || "/user/ja")?true:false}>

            <ArrowBackIcon/>
            </button>
              </div>
          </div>
        )}
        <div className={classes.navItems}>
          <ul>
            <li hidden={item === "external" ? true : false} >
              <Link
                style={{ color: "#FF762B" }}
                to="/user/new"
                className={classes.NavTabName}
              >
                Free Consultation*
              </Link>
              <Link
                style={{ color: "#FF762B" }}
                to="/user/new"
                className={classes.buttonNav}
              >
                <SettingsPhoneIcon />{" "}
              </Link>
            </li> 
            <li hidden={item === "external" ? true : false}>
              <Link to="/" className={classes.NavTabName}>
                Home
              </Link>
              <Link to="/" className={classes.buttonNav}>
                {" "}
                <HomeIcon />
              </Link>
            </li>
            {/* <li to="findContact/:implId/:id/currentday">On this day</li> */}

            <li>
              <Link to="/user/Usage" className={classes.NavTabName}>
                Usage
              </Link>
              <Link to="/user/Usage" className={classes.buttonNav}>
                <QueryStatsIcon />
              </Link>
            </li>

            {location.pathname !== "/login" ? (
              <li hidden={item === "external" ? true : false}>
                <Link to="/logout" className={classes.NavTabName}>
                  Logout
                </Link>
                <Link to="/logout" className={classes.buttonNav}>
                  <LogoutIcon />
                </Link>
              </li>
            ) : (
              <></>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
